

























import CommentHistory from '@getaccept/lib-shared/src/contextual-commenting/components/CommentHistory.vue';
import { useContextualCommentingStore } from '@getaccept/lib-shared/src/contextual-commenting/store/contextual-commenting.store';
import type { CurrentUser } from '@getaccept/lib-shared/src/contextual-commenting/types/current-user';
import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import type { SigningPageRecipient } from '@getaccept/lib-shared/src/types/signing-page-recipient';
import type { User } from '@getaccept/lib-shared/src/users/types/user';
import type { PropType, Ref } from '@vue/composition-api';
import { computed, defineComponent, ref, toRefs } from '@vue/composition-api';
import { storeToRefs } from 'pinia';
import DocumentAction from '../../components/DocumentAction.vue';
import { useContextualCommentingData } from '../contextual-commenting-data.composable';

export default defineComponent({
  components: {
    CommentHistory,
    DocumentAction,
  },
  props: {
    recipients: {
      type: Array as PropType<Recipient[]>,
      required: true,
    },
    sender: {
      type: Object as PropType<User>,
      required: true,
    },
    recipient: {
      type: Object as PropType<SigningPageRecipient>,
      required: true,
    },
  },
  setup(props) {
    const { recipient }: { recipient: Ref<SigningPageRecipient> } = toRefs(props);

    const isOpen = ref(false);

    const { updateComment, createReply, selectComment } = useContextualCommentingData();

    const { commentHistoryComments: comments, selectedCommentId, hoveredCommentId } = storeToRefs(
      useContextualCommentingStore()
    );

    const currentUser = computed<CurrentUser>(() => ({
      recipientId: recipient.value.id,
      name: recipient.value.fullName,
      thumbUrl: recipient.value.thumbUrl,
    }));

    const open = () => {
      isOpen.value = true;
    };

    const close = () => {
      isOpen.value = false;
    };

    return {
      comments,
      currentUser,
      selectComment,
      selectedCommentId,
      hoveredCommentId,
      open,
      close,
      isOpen,
      updateComment,
      createReply,
    };
  },
});
